import { TaskListQuery } from "@common/contracts/task.contract";
import { FiltersTypes } from "@common/types/filters/general";
import { toDateOnly } from "@design-system/DatePicker/DatePicker.lib";
import { TASK_PRIORITY_BY_FILTER_VALUE } from "@components/tasks/TaskPrioritySelect/taskPriority.constant";

interface BuildTaskListQueryParams {
    filters: TaskListQuery;
    overlayFilters: FiltersTypes;
}

export const buildTaskListQuery = ({
    filters,
    overlayFilters,
}: BuildTaskListQueryParams): TaskListQuery => ({
    ...filters,
    assigneeIds: overlayFilters.taskAssigneeIds,
    isUnassigned: overlayFilters.isTaskUnassigned,
    isAssignedToClient: overlayFilters.isTaskAssignedToClient,
    createdByIds: overlayFilters.taskCreatedByIds,
    isCreatedByClient: overlayFilters.isTaskCreatedByClient,
    clientIds: overlayFilters.taskClientIds,
    createdAtStart: toDateOnly(overlayFilters.taskCreatedAtStart),
    createdAtEnd: toDateOnly(overlayFilters.taskCreatedAtEnd),
    completedByIds: overlayFilters.taskCompletedByIds,
    completedAtStart: toDateOnly(overlayFilters.taskCompletedAtStart),
    completedAtEnd: toDateOnly(overlayFilters.taskCompletedAtEnd),
    closeIds: overlayFilters.taskCloseIds,
    priorities: overlayFilters.taskPriorities?.map(
        (value) => TASK_PRIORITY_BY_FILTER_VALUE[value],
    ),
    hasAttachments: overlayFilters.hasAttachments,
    taskGroupIds: overlayFilters.taskGroupIds,
    hasBlockedBy: overlayFilters.hasBlockedBy,
    hasBlocking: overlayFilters.hasBlocking,
    hasRelated: overlayFilters.hasRelated,
    hasUnreadChat: overlayFilters.hasUnreadChat,
    taskCloseStageIds: overlayFilters.taskCloseStageIds,
});
